export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tags.vue?vue&type=template&id=616b5a76&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/tags/tags.vue?vue&type=template&id=616b5a76&
// module id = 949
// module chunks = 0